export var FileUploadError;
(function (FileUploadError) {
    FileUploadError[FileUploadError["FAILED_UPLOADING_ATTACHMENT"] = -73001] = "FAILED_UPLOADING_ATTACHMENT";
    FileUploadError[FileUploadError["INVALID_EXTENSION"] = -73002] = "INVALID_EXTENSION";
    FileUploadError[FileUploadError["MAX_FILE_SIZE_EXCEEDED"] = -73003] = "MAX_FILE_SIZE_EXCEEDED";
})(FileUploadError || (FileUploadError = {}));
;
//# sourceMappingURL=file-upload-error.enum.js.map